import React, { useCallback, useEffect, useState } from "react";
import InputText from "../../../../components/inputs/InputText";
import InputDropSearch from "../../../../components/inputs/InputDropSearch";
import baseUrl from "../../../../api/baseUrl";
import PatientsReleaseModal from "../components/PatientsReleaseModal";
import { useNavigate } from "react-router-dom";

function PatientRelease() {
  const [formData, setformData] = useState<FormData>({
    patientId: "",
    total: 0,
    discount: 0,
    netTotal: 0,
    card: 0,
    cash: 0,
    product: [],
  });
  const [patients, setPatiens] = useState<Patients[]>([]);

  const [open, setopen] = useState(false);

  const getPatientsData = useCallback(async (search: string) => {
    try {
      const response = await baseUrl.get(
        "client/inventory/release/searchAllPatients",
        {
          headers: {
            keyword: search,
          },
        }
      );
      setPatiens(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }, []);
  useEffect(() => {
    getPatientsData("");
  }, [getPatientsData]);
  const handleChange = useCallback((e: any) => {
    const { name, value } = e.target;
    setformData((prevData) => {
      if (name === "discount") {
        return {
          ...prevData,
          [name]: value,
          netTotal: prevData.total - value,
        };
      } else if (name === "card") {
        return {
          ...prevData,
          [name]: value,
        };
      } else if (name === "cash") {
        return {
          ...prevData,
          [name]: value,
        };
      } else {
        return { ...prevData, [name]: value };
      }
    });
  }, []);
  const searchSupplier = useCallback(
    (e: any) => {
      getPatientsData(e);
    },
    [getPatientsData]
  );
  const openModal = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      setopen(true);
    },
    []
  );
  const closeModal = useCallback(() => {
    setopen(false);
  }, []);
  const addProduct = useCallback(
    (product: Product) => {
      setformData((prevFormData) => {
        const updatedProducts = [...prevFormData.product, product];
        const total = updatedProducts.reduce((sum, product) => {
          const price =
            typeof product.total === "string"
              ? parseFloat(product.total)
              : product.total;
          return sum + price;
        }, 0);

        return {
          ...prevFormData,
          product: updatedProducts,
          total: total,
          netTotal: total - prevFormData.discount,
        };
      });
      closeModal();
    },
    [closeModal]
  );
  const removeProductById = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>, id: string) => {
      event.preventDefault();
      setformData((prevFormData) => {
        // Filter out the product by id
        const updatedProducts = prevFormData.product.filter(
          (product: any) => product?.productId !== id
        );

        // Calculate the new total price
        const totalPrice = updatedProducts.reduce((sum, product) => {
          // Convert product.price to a number if it's a string
          const price =
            typeof product.total === "string"
              ? parseFloat(product.total)
              : product.total;
          return sum + price;
        }, 0);

        return {
          ...prevFormData,
          product: updatedProducts,
          total: totalPrice,
          netTotal: totalPrice - prevFormData.discount,
        };
      });
    },
    []
  );
  const navigate = useNavigate()

  const handleSubmit = (e: any) => {
    e.preventDefault();
    
    baseUrl
      .post("client/inventory/release/patientsProductRelease", formData)
      .then((response) => {
        navigate("/client/inventory/release/all-release")

      })
      .catch((error) => {
        console.error(error?.response);
      });
  };
  return (
    <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
      {open && (
        <PatientsReleaseModal addProduct={addProduct} closeModal={closeModal} />
      )}

      {/* Header */}
      <div className="px-3 py-2 border-b border-slate-200 dark:border-slate-600">
        <h3 className="text-xs font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span className="w-7 h-7 bg-primary/10 dark:bg-primary/20 rounded-md flex items-center justify-center text-primary text-xs">👤</span>
          Patient Release
        </h3>
      </div>

      <form onSubmit={handleSubmit} className="p-3 space-y-3">
        <InputDropSearch
          data={patients}
          name="patientId"
          label="Patient"
          selectName1="fullName"
          selectName2="regNo"
          selectValue="_id"
          onChange={handleChange}
          onSearch={searchSupplier}
        />

        <button
          type="button"
          onClick={(e: any) => openModal(e)}
          className="w-full px-3 py-2 rounded-lg border-2 border-dashed border-primary/30 dark:border-primary/50 text-primary font-medium hover:bg-primary/5 dark:hover:bg-primary/10 transition-colors flex items-center justify-center gap-1.5 text-xs"
        >
          <span className="text-base">+</span> Add Product
        </button>

        {formData?.product?.length > 0 && (
          <div className="border border-slate-200 dark:border-slate-600 rounded-lg overflow-hidden">
            <table className="w-full text-xs">
              <thead className="bg-slate-50 dark:bg-slate-700/50">
                <tr>
                  {tableHeader?.map((item: any, i: number) => (
                    <th key={i} className="px-2.5 py-1.5 text-left text-[10px] font-semibold text-slate-500 dark:text-slate-300 uppercase">
                      {item?.title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
                {formData?.product?.map((item: Product, i: number) => (
                  <tr key={i} className="hover:bg-slate-50 dark:hover:bg-slate-700/50">
                    <td className="px-2.5 py-1.5 text-xs text-slate-500 dark:text-slate-400">{i + 1}</td>
                    <td className="px-2.5 py-1.5 font-medium text-xs text-slate-700 dark:text-slate-200">{item?.productName}</td>
                    <td className="px-2.5 py-1.5 text-xs text-slate-600 dark:text-slate-300">{item?.unitPrice}</td>
                    <td className="px-2.5 py-1.5 text-xs text-slate-600 dark:text-slate-300">{item?.quantity}</td>
                    <td className="px-2.5 py-1.5 text-xs text-slate-600 dark:text-slate-300">{item?.discount}</td>
                    <td className="px-2.5 py-1.5 font-semibold text-xs text-emerald-600 dark:text-emerald-400">{item?.netTotal}</td>
                    <td className="px-2.5 py-1.5">
                      <button
                        type="button"
                        onClick={(e) => removeProductById(e, item?.productId)}
                        className="text-red-500 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 text-[10px] font-medium"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="grid grid-cols-2 gap-2.5">
          <InputText name="total" label="Total" value={formData.total} onChange={handleChange} isDisable={true} />
          <InputText name="discount" label="Discount" value={formData.discount} onChange={handleChange} />
        </div>

        <div className="p-2.5 bg-emerald-50 dark:bg-emerald-900/40 rounded-lg">
          <p className="text-xs text-emerald-700 dark:text-emerald-300">
            Net Total: <span className="font-bold text-sm">{formData.netTotal}</span>
          </p>
        </div>

        <div className="grid grid-cols-2 gap-2.5">
          <InputText name="card" label="Card" value={formData.card} onChange={handleChange} />
          <InputText name="cash" label="Cash" value={formData.cash} onChange={handleChange} />
        </div>

        <button
          type="submit"
          className="w-full px-4 py-2.5 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-semibold hover:shadow-lg hover:shadow-primary/20 transition-all text-xs"
        >
          Complete Payment
        </button>
      </form>
    </div>
  );
}

export default PatientRelease;
const tableHeader = [
  {
    title: "No",
  },
  {
    title: "produt Name",
  },
  {
    title: "unit",
  },
  {
    title: "amount",
  },
  {
    title: "discount",
  },
  {
    title: "net total",
  },
  {
    title: "Action",
  },
];
interface Patients {
  _id: string;
  fullName: string;
  regNo: string;
}
interface Product {
  productId: string;
  unitPrice: number;
  quantity: number;
  total: number;
  discount: number;
  netTotal: number;
  productName: string;
}

interface FormData {
  patientId: string;
  product: Product[];
  total: number;
  netTotal: number;
  discount: number;
  card: number;
  cash: number;
}
